<template>
    <el-dialog :title="title" :visible.sync="visibleSync" :close-on-click-modal="false" :width="_width">
        <div :style="{ 'max-height': `${this.screenHeight - 200}px`, overflow: `auto` }">
            <cus-form
                :ref="formName"
                :data="data"
                :columns="columns"
                :labelWidth="labelWidth"
                :labelPosition="labelPosition"
                @confirm="validate"
                @extrabutton-click="ExtraButtonClick($event)"
            ></cus-form>
        </div>
        <div slot="footer" class="dialog-footer" v-if="btnVisible">
            <el-button @click="visibleSync = false">取 消</el-button>
            <el-button type="primary" v-if="showconfirm" @click="Confirm">确 定</el-button>

            <!--操作区域-->
            <template v-if="buttons && buttons.length > 0">
                <el-button v-has-permission="button.permission" v-for="(button, index) in buttons" :key="index" @click.stop="OtherExtraButtonClick(button.emit, data)" :type="button.type">
                    <TextFormatter v-if="button.icon" type="icons" v-model="button.icon"></TextFormatter>
                    {{ button.label }}
                </el-button>
            </template>
        </div>
    </el-dialog>
</template>

<script>
import ItemInput from './ItemInput'
import { mapGetters } from 'vuex'

export default {
    name: `form-dialog`,
    components: { ItemInput },
    props: {
        data: Object,
        columns: Array,
        showconfirm: {
            type: Boolean,
            default: true
        },
        visible: Boolean,
        title: String,
        labelWidth: {
            type: String,
            default: `120px`
        },
        emit: {
            type: String,
            default: `confirm`
        },
        labelPosition: {
            type: String,
            validator: function(t) {
                return t === `top` || t === `left` || t === `right`
            },
            default: `left`
        },
        width: { type: String },
        footerVisible: {
            type: Boolean,
            default: true
        },
        buttons: Array
    },
    data() {
        return {
            formName: ``,
            emitName: this.emit,
            formdata: {},
            btnShow: true
        }
    },
    created() {
        this.formName = `form`
        this.btnShow = this.footerVisible
    },
    mounted() {

    },
    computed: {
        ...mapGetters([`screenHeight`]),
        visibleSync: {
            get: function() {
                let fn = this.formName
                if (this.$refs[fn] && !this.visible) {
                    let fn = this.formName
                    this.$refs[fn].clearField()
                }
                return this.visible
            },
            set: function(newval) {
                if (!newval) {
                    let fn = this.formName
                    this.$refs[fn].clearField()
                }
                this.$emit(`update:visible`, newval)
            }
        },
        btnVisible: {
            get: function() {
                return this.btnShow
            },
            set: function(val) {
                this.btnShow = val
            }
        },
        _width() {
            return this.width || (this.columns.length > 6 ? `50%` : `30%`)
        }
    },
    methods: {
        Confirm() {
            let that = this
            let fn = that.formName
            this.$refs[fn].isExtraBtnClick = false
            this.$refs[fn].confirm()
        },
        OtherExtraButtonClick(emit, data) {
            let that = this
            let fn = that.formName
            this.$refs[fn].isExtraBtnClick = true
            this.$refs[fn].confirm()
        },
        ExtraButtonClick(target) {
            this.$emit(`extrabutton-click`, target)
        },
        validate(data) {
            let that = this
            that.$emit(that.emitName, data)
        },
        clearField() {
            let fn = this.formName
            this.$refs[fn].clearField()
        }
    },
    watch: {
        footerVisible: function() {
            this.btnShow = this.footerVisible
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/FormDialog.vue